import React, { useState, useEffect } from 'react';
import { Box, Button, Grid } from '@mui/material';
import { Generals } from '../../enums/general.names.enum';
import expandButton from '../../Assets/AlertIcon/route.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { KmzLeftBarComponent } from './kmz_left_bar.component';
import DashboardLayout from '../../common/components/dashboard_layout.component';
import { useAtom, useSetAtom, useAtomValue } from 'jotai';
import {
  openKmzBar,
  openUploadKmz,
  kmzNetwork,
  allKmzs,
  regionForkmzNetwork,
  cityForkmzNetwork,
  partnerForkmzNetwork,
  citiesKmz,
  regionsKmz,
  geoServerResponseLinks,
  geoServerResponseSites,
  partnerOrRoute,
  allFetchedRoutes,
  selectedKmz,
} from '../../common/atom/atoms';
import CrossIcon from '../../Assets/AlertIcon/crossIcon.svg';
import UploadKmzModal from './upload_kmz_modal.component';
import KmzMapComponent from './kmz_map.component';
import { getAllKmzsWithFilters } from './functions/get_all_kmz_with_filters.function';
import { useBackdrop } from '../../common/components/backDrop_context.component';
// import { GeoServerLinksData } from './functions/geoServer_links_Data.function';
import { getAllRegions } from './functions/get_all_regions_kmz.function';
import { getAllCities } from './functions/get_all_cities.function';
import { LockedRouteLeftBarComponent } from './locked_routes_left_bar.component';
import { getRoutesForPoc } from '../Poc/functions/get_routes_for_poc.function';
import CompareRoutes from './compare_routes.component';
import circleIcon from '../../Assets/AlertIcon/circle.svg';
export const KmzMainComponent = () => {
  const [value, setValue] = useState(1);
  const [tabValue, setTabValue] = useState();
  const [allKmzData, setKmzData] = useAtom(allKmzs);
  const [partnerOrRouteValue, setPartnerOrRouteValue] = useAtom(partnerOrRoute);
  const [kmzBar, setKmzBar] = useAtom(openKmzBar);
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const kmzNetworks = useAtomValue(kmzNetwork);
  const kmzPartner = useAtomValue(partnerForkmzNetwork);
  const regionkmz = useAtomValue(regionForkmzNetwork);
  const citykmz = useAtomValue(cityForkmzNetwork);
  const setOpenUploadKmz = useSetAtom(openUploadKmz);
  const setGeoServerResponseSites = useSetAtom(geoServerResponseSites);
  const setAllFetchedRoutes = useSetAtom(allFetchedRoutes);
  const [updateRoute, setUpdateRoute] = useState(false);
  const setGeoServerResponseLinks = useSetAtom(geoServerResponseLinks);
  const setCities = useSetAtom(citiesKmz);
  const setRegions = useSetAtom(regionsKmz);
  const setSelectedKmz = useSetAtom(selectedKmz);
  const navigate = useNavigate();
  const location = useLocation();
  const permissionsJSON = localStorage.getItem('permissions');

  let permissions = [];
  try {
    permissions = JSON.parse(permissionsJSON) || [];
  } catch (error) {
    console.error('Failed to parse permissions:', error);
  }
  const permissionNames = Array.isArray(permissions)
    ? permissions.map((permission) => permission.name)
    : [];
  const [controllerTab, setControllerTab] = useState(Generals.user);
  const isKmzPlanningView = location.pathname.includes('/networkPlanning/kmzPlanning');
  const allowRouteFeatures = !isKmzPlanningView;

  useEffect(() => {
    // Check if none of the required permissions are present
    const hasPartnerNetworkAccess = permissionNames.includes('Partner Network');
    const hasKmzAccess = permissionNames.includes('KMZ');
    if (!hasPartnerNetworkAccess && !hasKmzAccess) {
      navigate('/rov');
      return;
    }
  }, [permissionNames, navigate]);
  const handleChange = (event, tabName) => {
    setValue(Number(event.target.value));
    setControllerTab(tabName);
  };
  const handleTabSelection = (tabValue) => {
    setTabValue(tabValue);
    sessionStorage.setItem('selectedTab', tabValue);
    navigate('/fibers');
  };
  const handleOpenUploadModal = () => {
    setSelectedKmz(null);
    setOpenUploadKmz(true);
  };
  useEffect(() => {
    getAllKmz();
    // getGeoServerDAataForLinksAndSites();
  }, [kmzNetworks, kmzPartner]);
  useEffect(() => {
    getAllKmz();
  }, [regionkmz, citykmz]);

  useEffect(() => {
    getAllCitiesKmz();
    getAllRegionsKmz();
  }, [kmzNetworks]);

  const getAllKmz = async () => {
    showBackdrop();
    try {
      // add regions and cities here
      const regionsArray = regionkmz ? [regionkmz] : [];
      const citiesArray = citykmz ? [citykmz] : [];

      const resp = await getAllKmzsWithFilters(
        '',
        '',
        kmzNetworks,
        kmzPartner,
        regionsArray,
        citiesArray
      );

      setKmzData(resp?.response);
      hideBackdrop();
    } catch (error) {
      console.error('Error fetching kmzs:', error);
    }
    hideBackdrop();
  };
  const getAllCitiesKmz = async () => {
    try {
      const resp = await getAllCities(kmzNetworks);
      setCities(resp?.response);
    } catch (error) {
      console.error('Error fetching kmzs:', error);
    }
  };
  const getAllRegionsKmz = async () => {
    try {
      const resp = await getAllRegions(kmzNetworks);
      setRegions(resp?.response);
    } catch (error) {
      console.error('Error fetching kmzs:', error);
    }
  };
  // const getGeoServerDAataForLinksAndSites = async () => {
  //   try {
  //     const resp = await GeoServerLinksData(kmzNetworks);
  //     setGeoServerResponseLinks(resp);
  //     const response = await GeoServerLinksData(kmzNetworks);
  //     setGeoServerResponseSites(response);
  //     // hideBackdrop()
  //   } catch (error) {
  //     console.error('Error fetching kmzs:', error);
  //     // hideBackdrop()
  //   }
  // };
  // Routes Functions

  const fetchRoutes = async () => {
    try {
      let routesData = await getRoutesForPoc();
      setAllFetchedRoutes(routesData);
    } catch (error) {
      console.error('Error fetching routes:', error);
    }
  };
  useEffect(() => {
    if (!allowRouteFeatures) {
      setPartnerOrRouteValue('partner');
      setAllFetchedRoutes([]);
      return;
    }
    fetchRoutes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allowRouteFeatures]);
  return (
    <>
      <UploadKmzModal getAllKmz={getAllKmz} />
      <DashboardLayout>
        <Box sx={{ flexGrow: 1, p: 0 }}>
          <Grid container spacing={0}>
            {kmzBar !== true && (
              <Grid item xs={11.5}>
                <Box
                  sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '4%',
                    zIndex: 999,
                    cursor: 'pointer',
                  }}
                  onClick={() => setKmzBar(true)}
                >
                  <img alt="" src={expandButton} style={{ width: '43px', height: '152px' }} />
                </Box>
              </Grid>
            )}

            {kmzBar && (
              <Grid
                className={`alert_notification_grid ${kmzBar ? 'open_alert_drawer' : 'close_alert_drawer'} `}
              >
                <div className="alerts_main" style={{ marginLeft: 0 }}>
                  {allowRouteFeatures && (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        background: '#DDDEDE',
                        borderRadius: 8,
                        padding: 4,
                        marginTop: '2%',
                        marginLeft: '5%',
                        gap: 4,
                      }}
                    >
                      {['partner', 'route'].map((type) => (
                        <div
                          key={type}
                          onClick={() => setPartnerOrRouteValue(type)}
                          style={{
                            cursor: 'pointer',
                            background: partnerOrRouteValue === type ? '#ffffff' : 'transparent',
                            borderRadius: 6,
                            padding: '6px 16px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontFamily: 'Poppins',
                            fontSize: 14,
                            fontWeight: partnerOrRouteValue === type ? '500' : '400',
                            color: partnerOrRouteValue === type ? '#192126' : 'rgba(0, 0, 0, 0.4)',
                            transition: 'all 0.2s ease',
                            width: '50%',
                          }}
                        >
                          {type === 'partner' ? 'Partner Routes' : 'Locked Routes'}
                        </div>
                      ))}
                    </div>
                  )}

                  {!allowRouteFeatures || partnerOrRouteValue === 'partner' ? (
                    <>
                      <div className="alerts_header">
                        <div className="alerts_title_icon">
                          <div
                            style={{
                              alignSelf: 'stretch',
                              marginTop: '8%',
                              marginLeft: '12%',
                              paddingBottom: 16,
                              borderBottom: '1px #E5E9EB solid',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              display: 'inline-flex',
                            }}
                          >
                            <div
                              style={{
                                width: 340,
                                height: 38,
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                display: 'inline-flex',
                              }}
                            >
                              <div
                                style={{
                                  color: 'black',
                                  fontSize: 20,
                                  fontFamily: 'Poppins',
                                  fontWeight: '500',
                                  wordWrap: 'break-word',
                                }}
                              >
                                KMZ List{' '}
                              </div>
                              <Button
                                variant="contained"
                                onClick={handleOpenUploadModal}
                                color="secondary"
                                style={{ backgroundColor: '#BD1D23', color: '#FFF' }}
                                startIcon={<CloudUploadIcon style={{ color: '#FFF' }} />}
                              >
                                Upload Kmz File
                              </Button>
                            </div>
                          </div>
                        </div>
                        <button className="crossButton" onClick={() => setKmzBar((prev) => !prev)}>
                          <img alt="cross icon" src={CrossIcon} />
                        </button>
                      </div>
                      <KmzLeftBarComponent />
                    </>
                  ) : (
                    <>
                      <button className="crossButton" onClick={() => setKmzBar((prev) => !prev)}>
                        <img alt="cross icon" src={CrossIcon} />
                      </button>

                      <LockedRouteLeftBarComponent setCreateRoutePopup={setUpdateRoute} />
                    </>
                  )}
                </div>
              </Grid>
            )}
            <div
              className={`alert_notification_grid ${kmzBar ? 'open_alert_content' : 'close_alert_content'} `}
            >
              <KmzMapComponent
                updateRoute={updateRoute}
                setUpdateRoute={setUpdateRoute}
                getAllKmz={getAllKmz}
                getAllRoutes={allowRouteFeatures ? fetchRoutes : undefined}
                setKmzData={setKmzData}
                filters={{
                  regionsArray: regionkmz ? [regionkmz] : [],
                  citiesArray: citykmz ? [citykmz] : [],
                  kmzNetworks,
                  kmzPartner,
                }}
                allowRouteEditing={allowRouteFeatures}
              />
            </div>
            {allowRouteFeatures && <CompareRoutes />}
          </Grid>
        </Box>
      </DashboardLayout>
    </>
  );
};
